enum GUEST_PAGE_KEY {
  /* 首頁 */
  HOME = 'Home',
  /* 服務 */
  SERVE = 'Serve',
  /* 專案 */
  PROJECT = 'Project',
  PROJECT_OVERVIEW = 'ProjectOverview',
  PROJECT_DETAIL = 'ProjectDetail',
  /* 聯絡我們 */
  CONTACT = 'Contact',
  /* 登入頁面 */
  SIGN_IN = 'SignIn'
}

export default GUEST_PAGE_KEY;
